import React from 'react';
import { I18n } from '@aws-amplify/core';
import SearchOutlined from '@ant-design/icons/SearchOutlined';
import { Row, Col, Form, type FormInstance } from 'antd';

import { PrimaryButton } from '@/components/ui/Button';
import { OrganizationFormItem } from './OrganizationFormItem';
import { WorkstationFormItem } from './WorkstationFormItem';
import { InitialDateFormItem } from './InitialDateFormItem';
import { ActionPlanFormItem } from './ActionPlanFormItem';
import { FinalDateFormItem } from './FinalDateFormItem';
import { CompanyFormItem } from './CompanyFormItem';
import { SectorFormItem } from './SectorFormItem';
import { ReportFormItem } from './ReportFormItem';
import { LineFormItem } from './LineFormItem';
import { NameFormItem } from './NameFormItem';
import { ToolFormItem } from './ToolFormItem';
import type { FormData, InitialValuesForm } from '@/components/Settings/DataExtraction/Filter/types';

interface FilterFormProps {
	form: FormInstance<FormData>;
	initialValues?: InitialValuesForm;
	isDisabledButtonSubmit?: boolean;
	onFinish: (values: FormData) => void;
	onClear: () => void;
}

export function FilterForm({
	form,
	initialValues = {},
	isDisabledButtonSubmit = false,
	onFinish,
	onClear
}: Readonly<FilterFormProps>): JSX.Element {
	return (
		<Form form={form} initialValues={initialValues} layout="vertical" onFinish={onFinish}>
			<Row gutter={[32, 32]}>
				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<OrganizationFormItem />
				</Col>
				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<CompanyFormItem />
				</Col>
				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<SectorFormItem />
				</Col>
				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<LineFormItem />
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<WorkstationFormItem />
				</Col>
				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<NameFormItem />
				</Col>
				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<InitialDateFormItem />
				</Col>
				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<FinalDateFormItem />
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<ReportFormItem />
				</Col>
				<Col xs={24} sm={12} md={8} lg={8} xl={6}>
					<ToolFormItem />
				</Col>
				<Col xs={24} sm={12} md={8} lg={10} xl={10}>
					<ActionPlanFormItem />
				</Col>
			</Row>
			<Row gutter={[32, { xs: 8 }]} style={{ marginTop: 32 }}>
				<Col xs={24} sm={12} md={6} lg={4}>
					<PrimaryButton htmlType="submit" icon={<SearchOutlined />} disabled={isDisabledButtonSubmit}>
						{I18n.get('Search')}
					</PrimaryButton>
				</Col>
				<Col xs={24} sm={12} md={6} lg={4}>
					<PrimaryButton ghost onClick={onClear}>
						{I18n.get('Clear')}
					</PrimaryButton>
				</Col>
			</Row>
		</Form>
	);
}
